import Vue from 'vue'
import Vuetify from 'vuetify'
//import VueClipboard from 'vue-clipboard2'
import App from './App'


import '@fortawesome/fontawesome-free/css/all.css'
import router from './router'

import 'vuetify/dist/vuetify.min.css'
//import '@voerro/vue-tagsinput/dist/style.css'
import { store } from './store'
import firebase from 'firebase'
//import Snotify, { SnotifyPosition } from 'vue-snotify'
//import 'vue-snotify/styles/material.css'; 
import './assets/main.scss'
//import Datepicker from 'vuejs-datepicker';
//import draggable from 'vuedraggable'
import Clipboard from 'v-clipboard'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'



// VIEWS
import NewOrder from './components/views/NewOrder'
import WeekReport from './components/views/WeekReport'
import AdditionalSales from './components/views/AdditionalSales'
import Promotions from './components/views/Promotions'

import Orders from './components/views/Orders'
import Stock from './components/views/Stock'
import Margins from './components/views/Margins'
import Companies from './components/views/Companies'
import Development from './components/views/Development'
//import Store from './components/views/Store'
import Products from './components/views/Products'
import Report from './components/views/Report'
import Staff from './components/views/Staff'
import Files from './components/views/Files'
//import Development from './components/views/Development'
import Partners from './components/views/Partners'
import Login from './components/views/Login'

// BLOCKS
import Navigation from './components/blocks/Navigation'
import MediaUpload from './components/blocks/MediaUpload'
import MediaGrid from './components/blocks/MediaGrid'
import MediaViewer from './components/blocks/MediaViewer'
import FetchDraftsModal from './components/blocks/FetchDraftsModal'

//import AddWholesaleCompany from './components/blocks/AddWholesaleCompany'
//import AddProductTag from './components/blocks/AddProductTag'
//import AddStaff from './components/blocks/AddStaff'
//import CustomersTable from './components/blocks/CustomersTable'
//import dateFormat from 'dateformat'
//import vmodal from 'vue-js-modal'
import VueApexCharts from 'vue-apexcharts'



/* const options = {
  toast: {
    position: SnotifyPosition.rightTop
  }
} */

//Vue.use(Snotify, options)
//Vue.use(VueClipboard)

//Vue.use(draggable)
//Vue.use(Datepicker)
//Vue.use(vmodal)
Vue.use(Clipboard)
Vue.use(vue2Dropzone)
const vuetifyOpts = {
  icons: {
    iconfont: 'fa', // 'md' || 'mdi' || 'fa' || 'fa4',
  },
  //theme: { disable: true },
  theme: {
    themes: { 
      light: {
        primary: '#cccccc',
        secondary: '#b0bec5',
        anchor: '#8c9eff',
        background:'#FFFFFF'
      },
    }
  },
  
}
Vue.use(Vuetify)

// VIEWS
Vue.component("NewOrder", NewOrder);
Vue.component("WeekReport", WeekReport);
Vue.component("AdditionalSales", AdditionalSales);
Vue.component("Promotions", Promotions);
Vue.component("Orders", Orders);
Vue.component("Development", Development);
Vue.component("Stock", Stock);
Vue.component("Margins", Margins);
Vue.component("Companies", Companies);
//Vue.component("Store", Store);
Vue.component("Products", Products);
Vue.component("Report", Report);
Vue.component("Staff", Staff);
Vue.component("Files", Files);
//Vue.component("Development", Development);
Vue.component("Partners", Partners);
Vue.component("Login", Login);

// BLOCKS
Vue.component("Navigation", Navigation);
Vue.component('apexchart', VueApexCharts)
Vue.component("vue-dropzone", vue2Dropzone);
Vue.component("MediaUpload", MediaUpload);
Vue.component("MediaGrid", MediaGrid);
Vue.component("MediaViewer", MediaViewer);
Vue.component("FetchDraftsModal", FetchDraftsModal);



Vue.mixin({
  methods: {
    
  }
})


var h = location.hostname
var authDomain = "sales.avecor.fi"
if(h === 'office.avecor.fi') authDomain = h
if(h === 'office-dev.avecor.fi') authDomain = 'office.avecor.fi'
if(h === 'sales.avecor.fi') authDomain = h
if(h === 'sales-dev.avecor.fi') authDomain = 'sales.avecor.fi'

if(h === 'office.logogear.fi') authDomain = h
if(h === 'logogear-erp.web.app') authDomain = h
if(h === 'logogear-erp.firebaseapp.com') authDomain = h
if(h === 'office-dev.logogear.fi') authDomain = 'office.logogear.fi'
if(h === 'sales.logogear.fi') authDomain = h
if(h === 'sales-dev.logogear.fi') authDomain = 'sales.logogear.fi'


// LOGOGEAR ERP CONFIG
var config = {
  apiKey: "AIzaSyAQoh6xiZmA1C8SSkxG8ZQhzXRtF35Gi_0",
  authDomain,
  databaseURL: "https://logogear-erp.firebaseio.com",
  projectId: "logogear-erp",
  storageBucket: "logogear-erp.firebasestorage.app",
  messagingSenderId: "126163658011",
  appId: "1:126163658011:web:13a5caad9294b2d2ed5fbe",
  measurementId: "G-0TBG7X4LWP",
  //clientId:"966659475093-a7nv1ji0pbt2jcf7jqtq3buuvj6ev699.apps.googleusercontent.com",
  scopes: [
    "email",
    "profile",
    "https://mail.google.com/"
  ],
  discoveryDocs: [
    "https://www.googleapis.com/discovery/v1/apis/gmail/v1/rest"
  ]
}

firebase.initializeApp(config)


const firestore = firebase.firestore();
const settings = {};//timestampsInSnapshots: true
firestore.settings(settings);
//firebase.firestore().enablePersistence()
/* firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL)
.then(() => {
  console.log("Persistence set to LOCAL");
})
.catch((error) => {
  console.error("Error setting persistence:", error);
}); */
Vue.config.productionTip = false
var vm;
/* eslint-disable no-new */
const unsubscribe = firebase.auth().onAuthStateChanged((firebaseUser) => {
  vm = new Vue({
    el: '#app',
    router,
    store,
    vuetify: new Vuetify(vuetifyOpts),
    render: h => h(App),
    created () {
      console.log(firebaseUser)
      if (firebaseUser) {
        if((store.state.settings.isOffice || store.state.settings.isSales) && (!firebaseUser.email.includes("@logogear.fi") && !firebaseUser.email.includes("@avecor.fi")) && !firebaseUser.email.includes("tomi.hokkanen")) {
          store.dispatch('userSignOut')
        }
        else if(firebaseUser.email.includes("mikael.hanslin")){
          store.dispatch('userSignOut')
        }
        else {
          store.dispatch('autoSignIn', firebaseUser)

          if (store.state.settings.isSales || store.state.settings.isOffice) {
            /* var script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = 'https://apis.google.com/js/api.js'//?onload=handleClientLoad';
            // Once the Google API Client is loaded, you can run your code
            gapi.load('client:auth2', {
              callback: function() {
                // Initialize the Google API Client with the config object
                gapi.client.init({
                  apiKey: config.apiKey,
                  clientId: config.clientId,
                  discoveryDocs: config.discoveryDocs,
                  scope: config.scopes.join(' '),
                })
                .then(function() {
                  //console.log("gapi loaded")
                  gapi.auth2.getAuthInstance().isSignedIn.listen(function() {
                    // Initialize the Google API Client with the config object
                    store.state.settings.debug ? console.log("GMAIL API AUTHENTICATED") : null
                    store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Lisäautentikointi onnistui. Tilausvahvistuksen sähköpostit toimivat nyt.", snackButtonText: "", errorType:"", snackColor:'success',right:true,top:true})
                  })
                  // Handle the initial sign-in state.
                  //updateSigninStatus(gapi.auth2.getAuthInstance().isSignedIn.get());
                  // Make sure the Google API Client is properly signed in
                  if (gapi.auth2.getAuthInstance().isSignedIn.get()) {
                    store.state.settings.debug ? console.log("GMAIL API AUTHENTICATED") : null
                    //gapi.auth2.getAuthInstance().signOut();
                  } else {
                    store.state.settings.debug ? console.log("GMAIL NOT AUTHENTICATED") : null
                    store.dispatch('showSnack', { snack:true, snackTimeout:0, snackText:"Lisäautenkikointi tarpeen tilausvahvistus sähköpostiviestejä varten.", snackButtonText: "Klikkaa tästä!", errorType:"gmailAuth", snackColor:'error',right:true,top:true})
                  }
                }, function(error) {
                  console.log(JSON.stringify(error, null, 2))
                })
              }
            }) */
          }
        }
      }
      else {
        console.log("no firebase user")
        if (firebase.auth().isSignInWithEmailLink(window.location.href)) {
          console.log("in sign in with email link")
          var email = window.localStorage.getItem('emailForSignIn');
          console.log(email)
          if (!email) {
            // User opened the link on a different device. To prevent session fixation
            // attacks, ask the user to provide the associated email again. For example:
            email = window.prompt('Please provide your email for confirmation');
          }
          firebase.auth().signInWithEmailLink(email, window.location.href)
            .then(function(result) {
              // Clear email from storage.
              //window.localStorage.removeItem('emailForSignIn');
              console.log(result)
              store.dispatch('autoSignIn', result.user)
              router.push("/")
            })
            .catch(function(error) {
              console.log(error)
            });
        }
      }
    }
  }).$mount('#app')
  unsubscribe()
})
global.vm = vm;



// WEBPACK FOOTER //
// ./src/main.js